
function getTranslation(transform) {
    // Create a dummy g for calculation purposes only. This will never
    // be appended to the DOM and will be discarded once this function 
    // returns.
    var g = document.createElementNS("http://www.w3.org/2000/svg", "g");
    
    // Set the transform attribute to the provided string value.
    g.setAttributeNS(null, "transform", transform);
    
    // consolidate the SVGTransformList containing all transformations
    // to a single SVGTransform of type SVG_TRANSFORM_MATRIX and get
    // its SVGMatrix. 
    var matrix = g.transform.baseVal.consolidate().matrix;
    
    // As per definition values e and f are the ones for the translation.
    return [matrix.e, matrix.f];
  }

//This does NOT take into account padding
function XLocationToHour(xLocation, visualiser){
    return (xLocation) / visualiser.params.xScaling + visualiser.simulator.hoursPassed;
}

//Calculate the scaled x location
function hourToXLocation(startHour, visualiser){
    return (startHour - visualiser.simulator.hoursPassed) * visualiser.params.xScaling + visualiser.params.paddingLeft;
}

module.exports ={
    getTranslation,
    hourToXLocation,
    XLocationToHour
}